export const profiles = [
    {
        img:
        "https://assets.website-files.com/62b46e994f1dca4537e494a5/63470c8cc610103129b743ad_Screen%20Shot%202021-09-20%20at%2016.21.35.png",
        name: "Carla Consolini",
        role: "VR Spanish Guide"
        },
    
        {
        img: "https://assets.website-files.com/62b46e994f1dca4537e494a5/62d768d6cddf7a3d1fd29a0e_Cguess-p-500.jpg",
        name: "Chris Guess",
        role: "Lead 3D Artist"
        },
    
        {
        img:
        "https://assets.website-files.com/62b46e994f1dca4537e494a5/62d76a5fe0e3cc380367ebd2_Screen%20Shot%202022-07-19%20at%207.37.10%20PM-p-500.png",
        name: "Christian Rowe",
        role: "Co-Founder, Chief Growth Officer"
        },
    
        {
        img: "https://assets.website-files.com/62b46e994f1dca4537e494a5/62eac6e2074f2d9cbc30c882_1559167727088.png",
        name: "Dan Lee",
        role: "Product Designer"
        },
    
        {
        img: "https://assets.website-files.com/62b46e994f1dca4537e494a5/62b46e994f1dcad06ae49611_daniel.jpeg",
        name: "Daniel Decker",
        role: "Customer Success Manager"
        },
    
        {
        img: "https://assets.website-files.com/62b46e994f1dca4537e494a5/62b46e994f1dcae90be49608_IMG-3399.jpeg",
        name: "Dylan Walch",
        role: "Co-Founder, Lead VR Developer"
        },
    
        {
        img: "https://assets.website-files.com/62b46e994f1dca4537e494a5/63618045aa5ace3bef9e03d0_elton%20xue.jpeg",
        name: "Elton Xue",
        role: "Software Engineer"
        },
    
        {
        img: "https://assets.website-files.com/62b46e994f1dca4537e494a5/62cf53d122f09c7a4fa647b7_stefy.jpeg",
        name: "Estefanía (Stefy) Padilla",
        role: "VR Spanish Guide"
        },
    
        {
        img:
        "https://assets.website-files.com/62b46e994f1dca4537e494a5/62b46e994f1dca83c5e49607_ScreenShot2022-05-04at1_39_11PM.png",
        name: "Jacob Furnari",
        role: "Co-Founder, Chief Product Officer"
        },
    
        {
        img: "https://assets.website-files.com/62b46e994f1dca4537e494a5/63470d483660a95ec7797101_Resume%20Picture.jpg",
        name: "Jose Flores",
        role: "VR Spanish Guide"
        },
    
        {
        img:
        "https://assets.website-files.com/62b46e994f1dca4537e494a5/62b46e994f1dca3628e4960b_ScreenShot2022-05-04at1_33_26PM.png",
        name: "Jung Woo Lee",
        role: "Lead Software Engineer"
        },
    
        {
        img:
        "https://assets.website-files.com/62b46e994f1dca4537e494a5/62b46e994f1dcae139e49610_ScreenShot2022-05-04at1_36_03PM.png",
        name: "Kazunobu Sawada",
        role: "Japan Director"
        },
    
        {
        img: "https://assets.website-files.com/62b46e994f1dca4537e494a5/62b46e994f1dcab427e4960c_miranda.jpeg",
        name: "Miranda Novash",
        role: "Research Writer"
        },
    
        {
        img: "https://assets.website-files.com/62b46e994f1dca4537e494a5/62b46e994f1dca830ee4960a_mistywilson.png",
        name: "Misty Wilson",
        role: "Head of Education"
        },
    
        {
        img: "https://assets.website-files.com/62b46e994f1dca4537e494a5/62d769b08fd3ca6d94bba134_IMG_2995.jpg",
        name: "Morgan Hays",
        role: "VR Spanish Guide"
        },
    
        {
        img: "https://assets.website-files.com/62b46e994f1dca4537e494a5/62b46e994f1dca6297e4960f_nergiz.jpeg",
        name: "Nergiz Kern",
        role: "Head of Research"
        },
    
        {
        img: "https://assets.website-files.com/62b46e994f1dca4537e494a5/62b46e994f1dcaa70fe49612_nicholas.jpeg",
        name: "Nicholas Zehl",
        role: "VR Developer"
        },
    
        {
        img:"https://assets.website-files.com/62b46e994f1dca4537e494a5/62b46e994f1dca5983e49605_ScreenShot2022-05-04at1_23_09PM.png",
        name: "Quinn Taber",
        role: "Founder & CEO"
        },
    
        {
        img:"https://assets.website-files.com/62b46e994f1dca4537e494a5/62b46e994f1dcac3dde4960e_ScreenShot2022-05-04at1_29_59PM.png",
        name: "Tricia Thrasher",
        role: "Research Manager"
        },
    
        {
        img:"https://assets.website-files.com/62b46e994f1dca4537e494a5/62b46e994f1dca446ee49614_ScreenShot2022-05-04at1_35_23PM.png",
        name: "Xavier Apostol",
        role: "VR Developer"
        },
    {
        img: "https://media.discordapp.net/attachments/986751086507483186/1040395987929280552/Giacomo.jpg",
        name: "Giacomo Granducci",
        role: "Italian Guide"
    },
    {
        img: "https://media.discordapp.net/attachments/986751086507483186/1040396035912126594/karim.jpg?width=662&height=625",
        name: "Zouhir Karim",
        role: "Arabic Guide"
    },
    {
        img: "https://media.discordapp.net/attachments/986751086507483186/1040396002689040414/Giada-Stracqualursi.jpeg?width=617&height=625",
        name: "Giada Stracqualursi",
        role: "Italian Guide"
    },
    {
        img: "https://media.discordapp.net/attachments/986751086507483186/1040396064206897273/Davide.jpg",
        name: "Davide Puziello",
        role: "Head of Education"
    },
    {
        img: "https://media.discordapp.net/attachments/986751086507483186/1040396023048196096/Janmanpreet-Singh.jpg?width=625&height=625",
        name: "Janmanpreet Singh",
        role: "Chief of Staff"
    }
]